exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".header--3uXie{position:relative;padding-left:6px}.header--3uXie img{height:35px}.text--2O__e{text-align:center;margin-bottom:10px}\n", "", {"version":3,"sources":["/workspace/src/widget/header/style.scss"],"names":[],"mappings":"AAAA,eACE,kBACA,gBAAiB,CAFnB,mBAII,WAAY,CACb,aAID,kBACA,kBAAmB,CAAA","file":"style.scss","sourcesContent":[".header {\n  position: relative;\n  padding-left: 6px;\n  img {\n    height: 35px;\n  }\n}\n\n.text {\n  text-align: center;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "header--3uXie",
	"text": "text--2O__e"
};